/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.platinium.vivier.ts
 *
 * Messages du lot P4, vivier « CV coups de cœur » (étapes, notes, tâches, historique, comparer, export) (chantier Platinium, cahier des charges
 * app/docs/CDC-PLATINIUM.md).
 *
 * Fichier créé VIDE et déjà branché par la vague 0 (fusionné dans fr.ts,
 * inscrit au garde-fou des sous-catalogues) : l'agent de ce lot n'écrit QUE
 * dans ce fichier. Les textes communs (statut, garde de l'espace, texte de
 * l'accord) sont dans fr.platinium.socle.ts : les réutiliser, ne pas les
 * redéfinir (le garde-fou refuse une clé définie deux fois).
 *
 * Règles : préfixe de clé « platinium.vivier. » ; vouvoiement, apostrophes
 * typographiques, aucun tiret cadratin, aucun mot « atelier » en dur, aucun
 * nom, lieu ni type d'événement écrit en dur ({eventTypeDef}).
 *
 * Lot P4 rempli le 2026-10-14. Les valeurs du profil (disponibilité,
 * diplôme, contrats, permis) reprennent les clés stockées par V157 ; une
 * valeur inconnue s'affiche telle quelle.
 *
 * Mikael - chef de projet - 2026-10-14
 */
export const messagesPlatiniumVivierFr: Record<string, string> = {
  // ── Généralités ────────────────────────────────────────────────────────
  'platinium.vivier.chargement': 'Chargement de votre vivier…',
  'platinium.vivier.reessayer': 'Réessayer',
  'platinium.vivier.fermer': 'Fermer',
  'platinium.vivier.annuler': 'Annuler',
  'platinium.vivier.erreur.liste': 'Votre vivier n’a pas pu être chargé.',
  'platinium.vivier.erreur.fiche': 'Cette fiche n’a pas pu être chargée.',
  'platinium.vivier.erreur.ecriture': 'L’enregistrement a échoué. Réessayez.',
  'platinium.vivier.erreur.export': 'L’export n’a pas pu être produit. Réessayez.',
  'platinium.vivier.erreur.comparer': 'La comparaison n’a pas pu être chargée.',
  'platinium.vivier.erreur.import': 'Les candidats retenus n’ont pas pu être lus.',
  'platinium.vivier.vide.titre': 'Votre vivier est vide',
  'platinium.vivier.vide.texte':
    'Ajoutez des candidats depuis l’onglet Rechercher (bouton « Coup de cœur »), ou importez d’un clic ceux que vous aviez retenus pendant {eventTypeDef}.',
  'platinium.vivier.compte':
    '{n, plural, one {# personne affichée} other {# personnes affichées}} sur {total}{choisis, plural, =0 {} one {, # sélectionnée} other {, # sélectionnées}}',
  'platinium.vivier.emploiTrouve': 'A trouvé un emploi',
  'platinium.vivier.sansCv': 'CV indisponible',
  'platinium.vivier.etapeDesactivee': '(étape désactivée)',
  'platinium.vivier.selectionner': 'Sélectionner {nom}',
  'platinium.vivier.selection.vider': 'Vider la sélection',

  // ── Vues et filtres ────────────────────────────────────────────────────
  'platinium.vivier.vue.label': 'Affichage du vivier',
  'platinium.vivier.vue.colonnes': 'Colonnes',
  'platinium.vivier.vue.liste': 'Liste',
  'platinium.vivier.colonnes.aide':
    'Faites glisser une carte d’une étape à l’autre, ou utilisez son menu « Déplacer vers… ».',
  'platinium.vivier.filtres.label': 'Filtrer le vivier',
  'platinium.vivier.filtres.texte': 'Nom, étiquette, commune, poste',
  'platinium.vivier.filtres.etape': 'Étape',
  'platinium.vivier.filtres.etoiles': 'Étoiles',
  'platinium.vivier.filtres.etoilesMin': '{n, plural, one {# étoile et plus} other {# étoiles et plus}}',
  'platinium.vivier.filtres.toutes': 'Toutes',
  'platinium.vivier.filtres.tous': 'Tous',
  'platinium.vivier.filtres.retard': 'Tâches en retard seulement',
  'platinium.vivier.filtres.aucun': 'Aucune personne ne correspond à ces filtres.',
  'platinium.vivier.tri.label': 'Trier par',
  'platinium.vivier.tri.ajout': 'Ajout le plus récent',
  'platinium.vivier.tri.mouvement': 'Dernier changement d’étape',
  'platinium.vivier.tri.nom': 'Nom',
  'platinium.vivier.tri.etape': 'Étape',
  'platinium.vivier.tri.etoiles': 'Étoiles',
  'platinium.vivier.tri.echeance': 'Prochaine échéance',
  'platinium.vivier.liste.etape': '{etape}, depuis le {date}',

  // ── Carte ──────────────────────────────────────────────────────────────
  'platinium.vivier.carte.responsable': 'Suivi par {nom}',
  'platinium.vivier.carte.taches': '{n, plural, one {# tâche} other {# tâches}}, prochaine le {date}',
  'platinium.vivier.carte.tachesSansDate': '{n, plural, one {# tâche à faire} other {# tâches à faire}}',
  'platinium.vivier.carte.tachesRetard': '{n, plural, one {# tâche en retard} other {# tâches, dont au moins une en retard}}',
  'platinium.vivier.deplacer.label': 'Déplacer {nom} vers une autre étape',
  'platinium.vivier.deplacer.choisir': 'Déplacer vers…',
  'platinium.vivier.deplace': 'Déplacé vers « {etape} ».',
  'platinium.vivier.deplaceNom': '{nom} est maintenant à l’étape « {etape} ».',

  // ── Origine d'un ajout ─────────────────────────────────────────────────
  'platinium.vivier.source.recherche': 'Ajouté depuis la recherche',
  'platinium.vivier.source.cv_recus': 'Ajouté depuis les CV reçus',
  'platinium.vivier.source.scan': 'Ajouté depuis Ma journée',
  'platinium.vivier.source.journal': 'Ajouté depuis la vue Tout',
  'platinium.vivier.source.import_retenus': 'Retenu pendant {eventTypeDef}',

  // ── Sélection : comparer, exporter ─────────────────────────────────────
  'platinium.vivier.comparer.bouton': 'Comparer',
  'platinium.vivier.comparer.aide': 'Cochez deux ou trois personnes pour les comparer.',
  'platinium.vivier.comparer.titre': 'Comparer les candidats',
  'platinium.vivier.comparer.recherche': 'En recherche',
  'platinium.vivier.comparer.oui': 'Oui',
  'platinium.vivier.comparer.derniereNote': 'Dernière note',
  'platinium.vivier.export.tout': 'Exporter le vivier',
  'platinium.vivier.export.selection': 'Exporter la sélection ({n})',
  'platinium.vivier.export.notes': 'Avec les notes',
  'platinium.vivier.export.aide':
    'Le tableur contient les étapes, étoiles, étiquettes, responsables et dates, jamais les CV ni les coordonnées. Chaque export est inscrit au journal.',

  // ── Import des retenus ─────────────────────────────────────────────────
  'platinium.vivier.import.ouvrir': 'Importer les retenus',
  'platinium.vivier.import.titre': 'Importer les candidats retenus pendant {eventTypeDef}',
  'platinium.vivier.import.aide':
    'CV retenus dans votre recherche, entretiens conclus par une proposition, scans notés coup de cœur. Seules les personnes qui ont accepté que les entreprises recherchent leur CV entrent dans votre vivier.',
  'platinium.vivier.import.aucun': 'Aucun candidat retenu à importer.',
  'platinium.vivier.import.total':
    '{n, plural, one {# personne retenue} other {# personnes retenues}} ({matches} par la recherche, {entretiens} en entretien, {scans} au scan ; une personne peut compter plusieurs fois)',
  'platinium.vivier.import.importables':
    '{n, plural, =0 {Aucune personne à importer} one {# personne à importer} other {# personnes à importer}}',
  'platinium.vivier.import.deja': '{n, plural, one {# déjà dans votre vivier} other {# déjà dans votre vivier}}',
  'platinium.vivier.import.sansAccord':
    '{n, plural, one {# personne sans accord, non importée} other {# personnes sans accord, non importées}}',
  'platinium.vivier.import.sansCv':
    '{n, plural, one {# personne sans CV actif, non importée} other {# personnes sans CV actif, non importées}}',
  'platinium.vivier.import.emploiTrouve':
    '{n, plural, one {# personne a trouvé un emploi, non importée} other {# personnes ont trouvé un emploi, non importées}}',
  'platinium.vivier.import.bouton': '{n, plural, one {Importer # personne} other {Importer # personnes}}',
  'platinium.vivier.import.ajoutes':
    '{n, plural, =0 {Aucune personne ajoutée} one {# personne ajoutée à votre vivier} other {# personnes ajoutées à votre vivier}}',
  'platinium.vivier.import.fait':
    '{n, plural, =0 {Aucune personne ajoutée.} one {# personne ajoutée à votre vivier.} other {# personnes ajoutées à votre vivier.}}',

  // ── Étapes de l'entreprise ─────────────────────────────────────────────
  'platinium.vivier.etapes.ouvrir': 'Régler les étapes',
  'platinium.vivier.etapes.titre': 'Les étapes de votre vivier',
  'platinium.vivier.etapes.aide':
    'Renommez, ajoutez, réordonnez ou désactivez les étapes. Une étape désactivée reste visible tant que des personnes s’y trouvent ; elle n’est jamais supprimée.',
  'platinium.vivier.etapes.libelle': 'Étape {n}',
  'platinium.vivier.etapes.active': 'Active',
  'platinium.vivier.etapes.monter': 'Monter l’étape {etape}',
  'platinium.vivier.etapes.descendre': 'Descendre l’étape {etape}',
  'platinium.vivier.etapes.ajouter': 'Ajouter une étape',
  'platinium.vivier.etapes.enregistrer': 'Enregistrer les étapes',
  'platinium.vivier.etapes.enregistrees': 'Étapes enregistrées.',
  'platinium.vivier.etapes.invalide': 'Chaque étape a besoin d’un nom, et une étape au moins doit rester active.',

  // ── Fiche ──────────────────────────────────────────────────────────────
  'platinium.vivier.fiche.titre': 'Fiche du candidat',
  'platinium.vivier.fiche.disparue':
    'Cette personne n’est plus dans votre vivier : elle a été retirée, ou elle a retiré son accord, et tout ce qui la concernait a été effacé.',
  'platinium.vivier.fiche.etape': 'Étape',
  'platinium.vivier.fiche.ajoute': 'Dans le vivier depuis le {date}, ajouté par {nom}',
  'platinium.vivier.fiche.suivi': 'Votre suivi',
  'platinium.vivier.fiche.cvContact': 'CV et coordonnées',
  'platinium.vivier.fiche.journalise': 'Chaque consultation est inscrite au journal, et la personne peut la voir.',
  'platinium.vivier.fiche.voirCv': 'Voir le CV',
  'platinium.vivier.fiche.coordonnees': 'Afficher les coordonnées',
  'platinium.vivier.fiche.nomComplet': 'Nom complet',
  'platinium.vivier.fiche.courriel': 'Courriel',
  'platinium.vivier.fiche.telephone': 'Téléphone',

  'platinium.vivier.profil.vide': 'La personne n’a pas encore précisé son profil.',
  'platinium.vivier.profil.situation': 'Situation',
  'platinium.vivier.profil.recherche': 'Recherche',
  'platinium.vivier.profil.secteur': 'Secteur',
  'platinium.vivier.profil.experience': 'Expérience',
  'platinium.vivier.profil.commune': 'Commune',
  'platinium.vivier.profil.mobilite': 'mobile à {km} km',
  'platinium.vivier.profil.dispo': 'Disponibilité',
  'platinium.vivier.profil.dispoDate': 'à partir du {date}',
  'platinium.vivier.profil.contrats': 'Contrats souhaités',
  'platinium.vivier.profil.temps': 'Temps de travail',
  'platinium.vivier.profil.diplome': 'Diplôme',
  'platinium.vivier.profil.permis': 'Permis et véhicule',
  'platinium.vivier.profil.vehiculeOui': 'véhiculé',
  'platinium.vivier.profil.vehiculeNon': 'sans véhicule',

  'platinium.vivier.valeur.dispo.immediate': 'Immédiate',
  'platinium.vivier.valeur.dispo.date': 'À une date',
  'platinium.vivier.valeur.dispo.preavis': 'En poste, avec préavis',
  'platinium.vivier.valeur.dispo.a_preciser': 'À préciser',
  'platinium.vivier.valeur.temps.plein': 'Temps plein',
  'platinium.vivier.valeur.temps.partiel': 'Temps partiel',
  'platinium.vivier.valeur.temps.indifferent': 'Indifférent',
  'platinium.vivier.valeur.diplome.sans': 'Sans diplôme',
  'platinium.vivier.valeur.diplome.cap_bep': 'CAP, BEP',
  'platinium.vivier.valeur.diplome.bac': 'Bac',
  'platinium.vivier.valeur.diplome.bac2': 'Bac +2',
  'platinium.vivier.valeur.diplome.bac3': 'Bac +3',
  'platinium.vivier.valeur.diplome.bac5': 'Bac +5',
  'platinium.vivier.valeur.diplome.doctorat': 'Doctorat',
  'platinium.vivier.valeur.contrat.cdi': 'CDI',
  'platinium.vivier.valeur.contrat.cdd': 'CDD',
  'platinium.vivier.valeur.contrat.interim': 'Intérim',
  'platinium.vivier.valeur.contrat.alternance': 'Alternance',
  'platinium.vivier.valeur.contrat.apprentissage': 'Apprentissage',
  'platinium.vivier.valeur.contrat.stage': 'Stage',
  'platinium.vivier.valeur.contrat.saisonnier': 'Saisonnier',
  'platinium.vivier.valeur.contrat.indifferent': 'Indifférent',
  'platinium.vivier.valeur.permis.aucun': 'Aucun permis',
  'platinium.vivier.valeur.permis.b': 'Permis B',
  'platinium.vivier.valeur.permis.b_en_cours': 'Permis B en cours',
  'platinium.vivier.valeur.permis.c': 'Permis C',
  'platinium.vivier.valeur.permis.ce': 'Permis CE',
  'platinium.vivier.valeur.permis.d': 'Permis D',
  'platinium.vivier.valeur.permis.autre': 'Autre permis',

  'platinium.vivier.etoiles.label': 'Étoiles',
  'platinium.vivier.etoiles.valeur': '{n, plural, one {# étoile} other {# étoiles}}',
  'platinium.vivier.etoiles.effacer': 'Retirer les étoiles',
  'platinium.vivier.etiquettes.label': 'Étiquettes',
  'platinium.vivier.etiquettes.nouvelle': 'Nouvelle étiquette',
  'platinium.vivier.etiquettes.ajouter': 'Ajouter',
  'platinium.vivier.etiquettes.retirer': 'Retirer l’étiquette {etiquette}',
  'platinium.vivier.responsable.label': 'Responsable',
  'platinium.vivier.responsable.aucun': 'Personne',
  'platinium.vivier.poste.label': 'Poste visé',
  'platinium.vivier.poste.aucun': 'Aucun poste précis',

  'platinium.vivier.notes.titre': 'Notes',
  'platinium.vivier.notes.vide': 'Aucune note pour l’instant.',
  'platinium.vivier.notes.nouvelle': 'Nouvelle note',
  'platinium.vivier.notes.ajoutSeul':
    'Une note ne se modifie pas et ne s’efface pas : elle garde ce que vous pensiez au moment où vous l’avez écrite.',
  'platinium.vivier.notes.ajouter': 'Ajouter la note',
  'platinium.vivier.notes.signature': '{nom}, le {date}',

  'platinium.vivier.taches.titre': 'Tâches et rappels',
  'platinium.vivier.taches.vide': 'Aucune tâche pour vous sur cette personne.',
  'platinium.vivier.taches.nouvelle': 'Nouvelle tâche',
  'platinium.vivier.taches.exemple': 'Relancer, envoyer une offre…',
  'platinium.vivier.taches.date': 'Échéance',
  'platinium.vivier.taches.heure': 'Heure (facultative)',
  'platinium.vivier.taches.ajouter': 'Ajouter la tâche',
  'platinium.vivier.taches.echeance': 'pour le {date}',
  'platinium.vivier.taches.pour': 'confiée à {nom}',
  'platinium.vivier.taches.enRetard': 'en retard',
  'platinium.vivier.taches.faitePar': 'faite par {nom}',

  'platinium.vivier.historique.titre': 'Historique',
  'platinium.vivier.historique.ajoute': 'Entrée dans le vivier : {source}',
  'platinium.vivier.historique.etape': 'Étape : {de}, puis {vers}',
  'platinium.vivier.historique.etoiles': '{n, plural, one {Note : # étoile} other {Note : # étoiles}}',
  'platinium.vivier.historique.etoilesRetirees': 'Étoiles retirées',
  'platinium.vivier.historique.etiquettes': 'Étiquettes modifiées',
  'platinium.vivier.historique.responsable': 'Responsable : {nom}',
  'platinium.vivier.historique.responsableRetire': 'Plus de responsable',
  'platinium.vivier.historique.poste': 'Poste visé : {titre}',
  'platinium.vivier.historique.posteRetire': 'Plus de poste visé',
  'platinium.vivier.historique.note': 'Note ajoutée',
  'platinium.vivier.historique.tache_creee': 'Tâche créée',
  'platinium.vivier.historique.tache_faite': 'Tâche faite',
  'platinium.vivier.historique.tache_rouverte': 'Tâche rouverte',
  'platinium.vivier.historique.cv_vu': 'CV consulté',
  'platinium.vivier.historique.coordonnees_vues': 'Coordonnées consultées',
  'platinium.vivier.historique.message_envoye': 'Message envoyé',
  'platinium.vivier.historique.entretien_propose': 'Entretien proposé',
  'platinium.vivier.historique.entretien_accepte': 'Entretien accepté par la personne',
  'platinium.vivier.historique.entretien_refuse': 'Entretien refusé par la personne',
  'platinium.vivier.historique.entretien_contre': 'Autre moment proposé par la personne',
  'platinium.vivier.historique.entretien_annule': 'Entretien annulé',
  'platinium.vivier.historique.entretien_termine': 'Entretien terminé',
  'platinium.vivier.historique.entretien_absent': 'Absence à l’entretien',
  'platinium.vivier.historique.evaluation': 'Entretien évalué',
  'platinium.vivier.historique.recrute': 'Recrutement déclaré',
  'platinium.vivier.historique.retire': 'Retiré du vivier',

  'platinium.vivier.retirer.bouton': 'Retirer du vivier',
  'platinium.vivier.retirer.confirmer':
    'Retirer {nom} du vivier ? Ses notes, ses tâches et son historique seront effacés pour toute votre entreprise.',
  'platinium.vivier.retirer.oui': 'Oui, retirer',
  'platinium.vivier.retirer.fait': '{nom} a été retiré de votre vivier.',
};
